import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Authenticated client — sends the session cookie with every request
const authClient = axios.create({ baseURL: API, withCredentials: true, timeout: 20000 });

// ----- Auth -----
export const postSession = (sessionId) =>
  authClient.post('/auth/session', {}, { headers: { 'X-Session-ID': sessionId } }).then((r) => r.data);
export const fetchMe = () => authClient.get('/auth/me').then((r) => r.data);
export const logout = () => authClient.post('/auth/logout').then((r) => r.data);

// ----- Public settings -----
export const fetchSettings = () => authClient.get('/settings').then((r) => r.data);

// ----- Admin: events -----
export const adminCreateEvent = (p) => authClient.post('/admin/events', p).then((r) => r.data);
export const adminUpdateEvent = (id, p) => authClient.put(`/admin/events/${id}`, p).then((r) => r.data);
export const adminDeleteEvent = (id) => authClient.delete(`/admin/events/${id}`).then((r) => r.data);

// ----- Admin: sermons -----
export const adminCreateSermon = (p) => authClient.post('/admin/sermons', p).then((r) => r.data);
export const adminUpdateSermon = (id, p) => authClient.put(`/admin/sermons/${id}`, p).then((r) => r.data);
export const adminDeleteSermon = (id) => authClient.delete(`/admin/sermons/${id}`).then((r) => r.data);

// ----- Admin: settings -----
export const adminUpdateSettings = (p) => authClient.put('/admin/settings', p).then((r) => r.data);

// ----- Admin: messages -----
export const adminGetMessages = () => authClient.get('/admin/messages').then((r) => r.data);

// ----- Admin: image upload -----
export const adminUpload = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return authClient
    .post('/admin/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((r) => ({ ...r.data, fullUrl: `${API}${r.data.url.replace('/api', '')}` }));
};

export default authClient;
